import { CreateComType } from '../../pages';
import * as yup from 'yup';
import React from 'react';

const CreateComTypeContainer = ({ closeModal }) => {
	const validationSchema = () => {
		return yup.object({
			name: yup.string().required('name is required'),
			targetType: yup.string().required('Target Type is required'),
			deductTax: yup.string().required('Do you want to deduct tax?'),
			commissionCalculation: yup
				.string()
				.required('commission calculation is required')
				.test(function () {
					return this.parent.commissionCalculation === 'BasicRate' &&
						this.parent.rate === 0
						? this.createError({
								message: 'Rate is required',
								path: 'rate',
						  })
						: this.parent.commissionCalculation === 'Fixed' &&
						  this.parent.fixedAmount === 0
						? this.createError({
								message: 'Fixed Amount is required',
								path: 'fixedAmount',
						  })
						: this.parent.commissionCalculation === 'Point' &&
						  this.parent.onePointValue === 0
						? this.createError({
								message: 'Value of a point is required',
								path: 'onePointValue',
						  })
						: true;
				}),
			disbursementPeriod: yup
				.string()
				.required('Disbursement Period calculation is required'),
			payDayOfMonth: yup.string().test(function () {
				return this.parent.disbursementPeriod === 'MONTHLY' &&
					this.parent.payDayOfMonth === ''
					? this.createError({
							message: 'Day of Month is required',
							path: 'payDayOfMonth',
					  })
					: true;
			}),
			payDayOfWeek: yup.string().test(function () {
				return this.parent.disbursementPeriod === 'WEEKLY' &&
					this.parent.payDayOfWeek === ''
					? this.createError({
							message: 'Day of Week is required',
							path: 'payDayOfWeek',
					  })
					: true;
			}),
		});
	};
	return <CreateComType closeModal={closeModal} validationSchema={validationSchema} />;
};

export default CreateComTypeContainer;
